import { marked } from "marked";

import { stripPrelude } from "./prelude";

export const escapeHtml = (text: string): string => {
  return text.replace(/[<"&]/g, (c) => "&#" + c.charCodeAt(0) + ";");
};

export const markdownContainsComments = (markdownString: string) => {
  const { body } = stripPrelude(markdownString);

  // Quick check before actually parsing the HTML.
  if (!body.includes("<!--")) {
    return false;
  }

  const template = document.createElement("template");
  template.innerHTML = marked(body);

  const walker = document.createTreeWalker(
    template.content,
    NodeFilter.SHOW_COMMENT
  );

  // `nextNode()` returns `null` if it can't find any.
  return walker.nextNode() !== null;
};
